import { takeLatest, takeLeading } from "starfx";

import { TContractorFormSource } from "@app/types/insider";

import { schema } from "../schema";
import { xThunk } from "../xapis";

import type { ThunkCtx, Next } from "starfx";
import type { TContractorsEditing } from "@app/statefx/schema/uiContractorsEditing.def";

export const setContractorsEditingProp = xThunk.create<
  Partial<TContractorsEditing>
>(
  "/thnks/setContractorsEditingProp",
  { supervisor: takeLatest },
  function* (ctx: ThunkCtx, next: Next) {
    const actions = [];

    for (const [_key, _value] of Object.entries(ctx.payload)) {
      const key = _key as keyof TContractorsEditing;
      const value = _value as TContractorsEditing[keyof TContractorsEditing];
      actions.push(
        schema.uiContractorsEditing.update({ key: key, value: value })
      );
    }
    yield* schema.update(actions);
    yield* next();
  }
);

export const fxInvoiceOverallSetCtorMirror =
  xThunk.create<TContractorFormSource>(
    "/thks/react/selectedMirroredContractor0",
    { supervisor: takeLeading },
    function* (ctx: ThunkCtx, next: Next) {
      yield* schema.update([
        schema.uiInvoiceOverall.update({
          key: "selectedCtorMirrorTab",
          value: ctx.payload,
        }),
      ]);
      yield* next();
    }
  );
